import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';

// Create an axios instance with a base URL
// Always use the environment variable or fallback to production backend
const baseURL = API_BASE_URL;

console.log('🌐 Environment mode:', import.meta.env.DEV ? 'development' : 'production');
console.log('🌐 Environment VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('🌐 Axios configured with base URL:', baseURL);
console.log('🌐 All environment variables:', import.meta.env);

const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 60000, // Increased timeout to 60 seconds for uploads
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor for adding auth token
axiosInstance.interceptors.request.use(
  (config) => {
    // Log the full URL being requested
    const fullURL = `${config.baseURL}${config.url}`;
    console.log('🌐 Making request to:', fullURL);

    const token = localStorage.getItem('authorToken');
    if (token) {
      // Add token in Authorization header
      config.headers.Authorization = `Bearer ${token}`;

      console.log('🔑 Request headers:', config.headers);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;

